/**
 * @file
 * Behaviors for the Side filters.
 */
/* eslint-disable max-len */

(function (Drupal) {
  var bootstrap;

  /**
   * Setup and attach the Popover behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.sidefilter = {
    attach: function (context, settings) {
      once('sideFilters', '.side-filters--container', context).forEach(
        function (element) {
          const listWrapper = document.querySelectorAll(
            'fieldset .side-filters--list-wrapper'
          );

          // Make sure the side filters exist before attempting to create things
          if (!element) {
            return;
          }

          const debounce = (func, delay) => {
            let debounceTimer;
            return function () {
              const context = this;
              const args = arguments;
              clearTimeout(debounceTimer);
              debounceTimer = setTimeout(
                () => func.apply(context, args),
                delay
              );
              func.apply(context, args);
            };
          };

          const wrapModal = () => {
            const windowWidth = window.innerWidth;
            const modalDialog = document.querySelector('.modal-dialog');
            const expandListBtn = document.querySelectorAll('.show-filters');

            // Wrap .modal-dialog in bootstrap modal wrapper
            if (windowWidth < 992) {
              // Make sure that it isn't already wrapped
              if (!modalDialog.closest('#side-filters--mobile-content')) {
                // Create an wrapper element with all of the bootstrap stuff
                const wrapperElement = document.createElement('div');
                wrapperElement.className = 'modal fade';
                wrapperElement.tabIndex = -1;
                wrapperElement.id = 'side-filters--mobile-content';
                wrapperElement.role = 'dialog';
                wrapperElement.setAttribute('aria-labelledby', 'filterLabel');
                wrapperElement.setAttribute('aria-hidden', 'true');
                modalDialog.parentNode.insertBefore(
                  wrapperElement,
                  modalDialog
                );
                wrapperElement.appendChild(modalDialog);
              }

              // For each of the fieldsets, hide them initially
              if (listWrapper) {
                listWrapper.forEach(function (element) {
                  element.classList.add('d-none');
                });
              }

              expandListBtn.forEach(function (button) {
                if (!button.dataset.eventAttached) {
                  button.addEventListener('click', function () {
                    if (button.innerHTML === 'add') {
                      this.innerHTML = 'remove';
                    }
                    else {
                      this.innerHTML = 'add';
                    }

                    // Get closest fieldset to the clicked .show-filters element
                    var parentFieldset = button.closest('fieldset');

                    // If a fieldset is found, toggle d-none class on the .side-filters--list-wrapper elements within it
                    if (parentFieldset) {
                      var listWrappers = parentFieldset.querySelectorAll(
                        '.side-filters--list-wrapper'
                      );
                      if (listWrappers.length) {
                        listWrappers.forEach(function (listWrapper) {
                          listWrapper.classList.toggle('d-none');
                        });
                      }
                    }
                  });
                  button.dataset.eventAttached = 'true';
                }
              });
            }
            else {
              // Move .modal-dialog out of the wrapper when window width >= 991px
              const wrapper = document.getElementById(
                'side-filters--mobile-content'
              );
              const modalBackdrop = document.querySelector('.modal-backdrop');

              if (wrapper) {
                wrapper.parentNode.insertBefore(modalDialog, wrapper);
                wrapper.parentNode.removeChild(wrapper);
              }

              if (modalBackdrop) {
                modalBackdrop.parentNode.removeChild(modalBackdrop);
                if(document.body.style.overflow === 'hidden') {
                  document.body.style.overflow = 'visible';
                }
              }

              if (listWrapper) {
                listWrapper.forEach(function (element) {
                  element.classList.remove('d-none');
                });
              }
            }
          };

          // Run the logic once at the start
          wrapModal();
          window.addEventListener('resize', debounce(wrapModal, 150));

          // Handle the reset button being clicked
          const resetButton = document.querySelector('.reset-filters');
          if (resetButton) {
            resetButton.addEventListener('click', function () {
              window.location.reload();
            });
          }

          // Hide more than 7 items on load
          listWrapper.forEach(function (element) {
            const listItems = element.querySelectorAll('.side-filters--list');
            listItems.forEach(function (item, i) {
              if (i > 7) {
                item.classList.add('list-hidden', 'list-extra');
              }
            });
          });

          // Click function for view more / view less
          const listView = document.querySelectorAll('.side-filters--view');
          if (listView) {
            listView.forEach((item) =>
              item.addEventListener('click', function (e) {
                e.stopPropagation();
                const listItems = this.parentElement.querySelectorAll(
                  '.side-filters--list'
                );
                listItems.forEach(function (item) {
                  if (item.classList.contains('list-extra')) {
                    item.classList.toggle('list-hidden');
                  }
                });
                if (this.innerHTML === 'View All') {
                  this.innerHTML = 'View Less';
                }
                else {
                  this.innerHTML = 'View All';
                }
              })
            );
          }
        }
      );
    }
  };
})(Drupal);
